import { chat } from '../../stores/chat';
import { ChatSocket } from '../../hooks/use-socket';
import { ChatDelete } from '../../types/bingo-events/in/chat/delete';
import { isSuspended, onSuspend } from '../../lib/suspension';

const DELETE_ANIMATION_MS = 750;

export const onDelete = (socket: ChatSocket) => {
    const timers = new Set<ReturnType<typeof setTimeout>>();
    const cancel = () => {
        timers.forEach(clearTimeout);
        timers.clear();
    };
    const unsubscribe = onSuspend(cancel);
    const callback = (response: ChatDelete) => {
        chat.messages.set((messages) =>
            messages.map((m) =>
                m.messageId === response.messageId
                    ? { ...m, pendingDelete: true }
                    : m
            )
        );

        const timer = setTimeout(() => {
            timers.delete(timer);
            if (isSuspended()) return;
            chat.messages.set((messages) =>
                messages.filter((m) => m.messageId !== response.messageId)
            );

            if (response.message.trim()) {
                chat.messages.merge([
                    {
                        message: response.message,
                        isSystemMsg: true,
                        isWelcomeMsg: false,
                    },
                ]);
            }
        }, DELETE_ANIMATION_MS);
        timers.add(timer);
    };

    socket.on('delete:parlay', callback);

    return () => {
        unsubscribe();
        cancel();
        socket.off('delete:parlay', callback);
    };
};
